import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CartActionClearComponent } from './cart-action-clear';
import { CartActionShareComponent } from './cart-action-share';

@Component({
  selector: 'sd-cart-actions',
  imports: [CartActionShareComponent, CartActionClearComponent],
  templateUrl: './cart-actions.component.html',
  styleUrls: ['./cart-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartActionsComponent {}
